import { sbaAxios } from "../utils/sbaAxios";
import {
    getAttributesdetails, getChartofaccounts, getCurrencyInfo, getLegalStructure, getAssetSecurityType, getInvestmentType, getInvestorLetterFrequency,
    getPerformanceEstimateFrequency, getReportingFrequency, getExposureReportingFrequency, getFilingStatus, getInvestsInOtherFunds, getAssetRatings
} from "../../config/apiConfig";
import {
    FETCH_ATTRIBUTES_BEGIN,
    FETCH_ATTRIBUTES_SUCCESS,
    FETCH_ATTRIBUTES_FAILURE,

    FETCH_ATTRIBUTESACCOUNTS_BEGIN,
    FETCH_ATTRIBUTESACCOUNTS_SUCCESS,
    FETCH_ATTRIBUTESACCOUNTS_FAILURE,

    FETCH_ATTRIBUTECURRENCYINFO_BEGIN,
    FETCH_ATTRIBUTECURRENCYINFO_SUCCESS,
    FETCH_ATTRIBUTECURRENCYINFO_FAILURE,

    FETCH_ATTRIBUTELEGALSTRUCTURE_BEGIN,
    FETCH_ATTRIBUTELEGALSTRUCTURE_SUCCESS,
    FETCH_ATTRIBUTELEGALSTRUCTURE_FAILURE,

    FETCH_ASSETSECURITYTYPE_BEGIN,
    FETCH_ASSETSECURITYTYPE_SUCCESS,
    FETCH_ASSETSECURITYTYPE_FAILURE,

    FETCH_ASSETINVESTMENTTYPE_BEGIN,
    FETCH_ASSETINVESTMENTTYPE_SUCCESS,
    FETCH_ASSETINVESTMENTTYPE_FAILURE,

    FETCH_INVESTORLETTERFREQUENCY_BEGIN,
    FETCH_INVESTORLETTERFREQUENCY_SUCCESS,
    FETCH_INVESTORLETTERFREQUENCY_FAILURE,

    FETCH_PERFORMANCEESTIMATEFREQUENCY_BEGIN,
    FETCH_PERFORMANCEESTIMATEFREQUENCY_SUCCESS,
    FETCH_PERFORMANCEESTIMATEFREQUENCY_FAILURE,

    FETCH_REPORTINGFREQUENCY_BEGIN,
    FETCH_REPORTINGFREQUENCY_SUCCESS,
    FETCH_REPORTINGFREQUENCY_FAILURE,

    FETCH_EXPOSUREREPORTINGFREQUENCY_BEGIN,
    FETCH_EXPOSUREREPORTINGFREQUENCY_SUCCESS,
    FETCH_EXPOSUREREPORTINGFREQUENCY_FAILURE,

    FETCH_FILLINGSTATUS_BEGIN,
    FETCH_FILLINGSTATUS_SUCCESS,
    FETCH_FILLINGSTATUS_FAILURE,

    FETCH_INVESTSINOTHERFUNDS_BEGIN,
    FETCH_INVESTSINOTHERFUNDS_SUCCESS,
    FETCH_INVESTSINOTHERFUNDS_FAILURE,

    FETCH_ASSETRATINGS_BEGIN,
    FETCH_ASSETRATINGS_SUCCESS,
    FETCH_ASSETRATINGS_FAILURE,

    FETCH_ASSETODDRATINGS_BEGIN,
    FETCH_ASSETODDRATINGS_SUCCESS,
    FETCH_ASSETODDRATINGS_FAILURE

  } from '../constants/assetAttributes';

  export const getAssetAttributes=  (assetID)=> {
    return  (dispatch) => {
        dispatch(fetchAttributesBegin());
        sbaAxios({
            url: `${getAttributesdetails}${assetID}`,
            method: 'get',
        })
       .then((repos) => {
         const Attributes = repos;
         dispatch(fetchAttributesSuccess(Attributes));
         return Attributes;
       })
       .catch((error) =>{ return dispatch(fetchAttributesFailure(error))});
   };
 }
 
 export const fetchAttributesBegin = () => ({
   type: FETCH_ATTRIBUTES_BEGIN,
 });
 
 export const fetchAttributesSuccess = (attributesDetails) => ({
   type: FETCH_ATTRIBUTES_SUCCESS,
   payload: {attributesDetails},
 });
 
 
 export const fetchAttributesFailure = (errorMessage) => ({
   type: FETCH_ATTRIBUTES_FAILURE,
   payload: {errorMessage}
});

// CHART
export const getAssetchart = () => {
    return (dispatch) => {
        dispatch(fetchAttributesAccountBegin());
        sbaAxios({
            url: `${getChartofaccounts}`,
            method: 'get',
        })
            .then((repos) => {
                const AttributesAccount = repos;
                dispatch(fetchAttributesAccountSuccess(AttributesAccount));
                return AttributesAccount;
            })
            .catch((error) => { return dispatch(fetchAttributesAccountFailure(error)) });
    };
}

export const fetchAttributesAccountBegin = () => ({
    type: FETCH_ATTRIBUTESACCOUNTS_BEGIN,
});

export const fetchAttributesAccountSuccess = (chartofaccounts) => ({
    type: FETCH_ATTRIBUTESACCOUNTS_SUCCESS,
    payload: { chartofaccounts },
});
export const fetchAttributesAccountFailure = (errorMessage) => ({
    type: FETCH_ATTRIBUTESACCOUNTS_FAILURE,
    payload: { errorMessage }
});


// ATTRIBUTE CURRENCY INFO
export const getAttributescurrency = () => {
    return (dispatch) => {
        dispatch(fetchAttributescurrencyBegin());
        sbaAxios({
            url: `${getCurrencyInfo}`,
            method: 'get',
        })
            .then((repos) => {
                const Attributescurrency = repos;
                dispatch(fetchAttributescurrencySuccess(Attributescurrency));
                return Attributescurrency;
            })
            .catch((error) => { return dispatch(fetchAttributescurrencyFailure(error)) });
    };
}

export const fetchAttributescurrencyBegin = () => ({
    type: FETCH_ATTRIBUTECURRENCYINFO_BEGIN,
});

export const fetchAttributescurrencySuccess = (attributescurrency) => ({
    type: FETCH_ATTRIBUTECURRENCYINFO_SUCCESS,
    payload: { attributescurrency },
});


export const fetchAttributescurrencyFailure = (errorMessage) => ({
    type: FETCH_ATTRIBUTECURRENCYINFO_FAILURE,
    payload: { errorMessage }
});


//  LegalStructure
export const getAttributelegalStructure = () => {
    return (dispatch) => {
        dispatch(fetchAttributelegalStructureBegin());
        sbaAxios({
            url: `${getLegalStructure}`,
            method: 'get',
        })
            .then((repos) => {
                const Attributelegal = repos;
                dispatch(fetchAttributelegalStructureSuccess(Attributelegal));
                return Attributelegal;
            })
            .catch((error) => { return dispatch(fetchAttributelegalStructureFailure(error)) });
    };
}

export const fetchAttributelegalStructureBegin = () => ({
    type: FETCH_ATTRIBUTELEGALSTRUCTURE_BEGIN,
});

export const fetchAttributelegalStructureSuccess = (attributelegalstructure) => ({
    type: FETCH_ATTRIBUTELEGALSTRUCTURE_SUCCESS,
    payload: { attributelegalstructure },
});
export const fetchAttributelegalStructureFailure = (errorMessage) => ({
    type: FETCH_ATTRIBUTELEGALSTRUCTURE_FAILURE,
    payload: { errorMessage }
});

//  Security Type
export const getSecurityType = () => {
    return (dispatch) => {
        dispatch(fetchAssetSecurityTypeBegin());
        sbaAxios({
            url: `${getAssetSecurityType}`,
            method: 'get',
        })
            .then((repos) => {
                const SecurityType = repos;
                dispatch(fetchAssetSecurityTypeSuccess(SecurityType));
                return SecurityType;
            })
            .catch((error) => { return dispatch(fetchAssetSecurityTypeFailure(error)) });
    };
}

export const fetchAssetSecurityTypeBegin = () => ({
    type: FETCH_ASSETSECURITYTYPE_BEGIN,
});

export const fetchAssetSecurityTypeSuccess = (securityType) => ({
    type: FETCH_ASSETSECURITYTYPE_SUCCESS,
    payload: { securityType },
});
export const fetchAssetSecurityTypeFailure = (errorMessage) => ({
    type: FETCH_ASSETSECURITYTYPE_FAILURE,
    payload: { errorMessage }
});

//  InvestmentType
export const getAssetInvestmentType = () => {
    return (dispatch) => {
        dispatch(fetchAssetInvestmentTypeBegin());
        sbaAxios({
            url: `${getInvestmentType}`,
            method: 'get',
        })
            .then((repos) => {
                const InvestmentType = repos;
                dispatch(fetchAssetInvestmentTypeSuccess(InvestmentType));
                return InvestmentType;
            })
            .catch((error) => { return dispatch(fetchAssetInvestmentTypeFailure(error)) });
    };
}

export const fetchAssetInvestmentTypeBegin = () => ({
    type:  FETCH_ASSETINVESTMENTTYPE_BEGIN,
});

export const fetchAssetInvestmentTypeSuccess = (investmentType) => ({
    type:  FETCH_ASSETINVESTMENTTYPE_SUCCESS,
    payload: { investmentType },
});
export const fetchAssetInvestmentTypeFailure = (errorMessage) => ({
    type:  FETCH_ASSETINVESTMENTTYPE_FAILURE,
    payload: { errorMessage }
});
 
//  Investor LetterFrequency
export const getInvestorFrequency = () => {
    return (dispatch) => {
        dispatch(fetchInvestorFrequencyBegin());
        sbaAxios({
            url: `${getInvestorLetterFrequency}`,
            method: 'get',
        })
            .then((repos) => {
                const InvestorFrequency = repos;
                dispatch(fetchInvestorFrequencySuccess(InvestorFrequency));
                return InvestorFrequency;
            })
            .catch((error) => { return dispatch(fetchInvestorFrequencyFailure(error)) });
    };
}

export const fetchInvestorFrequencyBegin = () => ({
    type:  FETCH_INVESTORLETTERFREQUENCY_BEGIN,
});

export const fetchInvestorFrequencySuccess = (investorFrequency) => ({
    type:  FETCH_INVESTORLETTERFREQUENCY_SUCCESS,
    payload: { investorFrequency },
});
export const fetchInvestorFrequencyFailure = (errorMessage) => ({
    type: FETCH_INVESTORLETTERFREQUENCY_FAILURE,
    payload: { errorMessage }
});


//PerformanceEstimateFrequency
export const getEstimateFrequency = () => {
    return (dispatch) => {
        dispatch(fetchInvestorFrequencyBegin());
        sbaAxios({
            url: `${getPerformanceEstimateFrequency}`,
            method: 'get',
        })      
            .then((repos) => {
                const EstimateFrequency = repos;
                dispatch(fetchPerformanceEstimateFrequencySuccess(EstimateFrequency));
                return EstimateFrequency;
            })
            .catch((error) => { return dispatch(fetchPerformanceEstimateFrequencyFailure(error)) });
    };
}

export const fetchPerformanceEstimateFrequencyBegin = () => ({
    type:   FETCH_PERFORMANCEESTIMATEFREQUENCY_BEGIN,
});

export const fetchPerformanceEstimateFrequencySuccess = (performanceEstimateFrequency) => ({
    type:   FETCH_PERFORMANCEESTIMATEFREQUENCY_SUCCESS,
    payload: { performanceEstimateFrequency },
});
export const fetchPerformanceEstimateFrequencyFailure = (errorMessage) => ({
    type:  FETCH_PERFORMANCEESTIMATEFREQUENCY_FAILURE,
    payload: { errorMessage }
});

//ReportingFrequency
export const getAssetReportingFrequency = () => {
    return (dispatch) => {
        dispatch(fetchInvestorFrequencyBegin());
        sbaAxios({
            url: `${getReportingFrequency}`,
            method: 'get',
        })
            .then((repos) => {
                const ReportingFrequency = repos;
                dispatch(fetchReportingFrequencySuccess(ReportingFrequency));
                return ReportingFrequency;
            })
            .catch((error) => { return dispatch(fetchReportingFrequencyFailure(error)) });
    };
}

export const fetchReportingFrequencyBegin = () => ({
    type:  FETCH_REPORTINGFREQUENCY_BEGIN,
});

export const fetchReportingFrequencySuccess = (reportingFrequency) => ({
    type:    FETCH_REPORTINGFREQUENCY_SUCCESS,
    payload: { reportingFrequency },
});
export const fetchReportingFrequencyFailure = (errorMessage) => ({
    type:   FETCH_REPORTINGFREQUENCY_FAILURE,
    payload: { errorMessage }
});
//ExposureReportingFrequency

export const getExposuresReportingFrequency = () => {
    return (dispatch) => {
        dispatch(fetchExposureReportingFrequencyBegin());
        sbaAxios({
            url: `${getExposureReportingFrequency}`,
            method: 'get',
        })
            .then((repos) => {
                const ExposureReportingFrequency = repos;
                dispatch(fetchExposureReportingFrequencySuccess(ExposureReportingFrequency));
                return ExposureReportingFrequency;
            })
            .catch((error) => { return dispatch(fetchExposureReportingFrequencyFailure(error)) });
    };
}

export const fetchExposureReportingFrequencyBegin = () => ({
    type:  FETCH_EXPOSUREREPORTINGFREQUENCY_BEGIN,
});

export const fetchExposureReportingFrequencySuccess = (exposureReportingFrequency) => ({
    type:    FETCH_EXPOSUREREPORTINGFREQUENCY_SUCCESS,
    payload: { exposureReportingFrequency },
});
export const fetchExposureReportingFrequencyFailure = (errorMessage) => ({
    type:   FETCH_EXPOSUREREPORTINGFREQUENCY_FAILURE,
    payload: { errorMessage }
});

//Filing Status

export const getAssetFilingStatus = () => {
    return (dispatch) => {
        dispatch(fetchFilingStatusBegin());
        sbaAxios({
            url: `${getFilingStatus}`,
            method: 'get',
        })
            .then((repos) => {
                const ExposureReportingFrequency = repos;
                dispatch(fetchFilingStatusSuccess(ExposureReportingFrequency));
                return ExposureReportingFrequency;
            })
            .catch((error) => { return dispatch(fetchFilingStatusFailure(error)) });
    };
}

export const fetchFilingStatusBegin = () => ({
    type:  FETCH_FILLINGSTATUS_BEGIN,
});

export const fetchFilingStatusSuccess = (filingStatus) => ({
    type:    FETCH_FILLINGSTATUS_SUCCESS,
    payload: { filingStatus },
});
export const fetchFilingStatusFailure = (errorMessage) => ({
    type:   FETCH_FILLINGSTATUS_FAILURE,
    payload: { errorMessage }
});

//InvestsInOtherFunds

export const getInvestInOtherFunds = () => {
    return (dispatch) => {
        dispatch(fetchInvestInOtherFundsBegin());
        sbaAxios({
            url: `${getInvestsInOtherFunds}`,
            method: 'get',
        })
            .then((repos) => {
                const Investdata = repos;
                dispatch(fetchInvestInOtherFundsSuccess(Investdata));
                return Investdata;
            })
            .catch((error) => { return dispatch(fetchInvestInOtherFundsFailure(error)) });
    };
}

export const fetchInvestInOtherFundsBegin = () => ({
    type:  FETCH_INVESTSINOTHERFUNDS_BEGIN,
});

export const fetchInvestInOtherFundsSuccess = (investInOtherFunds) => ({
    type:    FETCH_INVESTSINOTHERFUNDS_SUCCESS,
    payload: { investInOtherFunds },
});
export const fetchInvestInOtherFundsFailure = (errorMessage) => ({
    type:   FETCH_INVESTSINOTHERFUNDS_FAILURE,
    payload: { errorMessage }
});


// asset rating  
export const getAssetRatingsAction = (assetID) => {
    return (dispatch) => {
        dispatch(fetchAttributesAssetRatingsBegin());
        sbaAxios({
            url: `${getAssetRatings}${assetID},${1}`,
            method: 'get',
        })
            .then((repos) => {
                const AttributesRating = repos;
                dispatch(fetchAttributesAssetRatingsSuccess(AttributesRating));
                return AttributesRating;
            })
            .catch((error) => { return dispatch(fetchAttributesAssetRatingsFailure(error)) });
    };
}

export const fetchAttributesAssetRatingsBegin = () => ({
    type: FETCH_ASSETRATINGS_BEGIN,
});

export const fetchAttributesAssetRatingsSuccess = (AttributesRating) => ({
    type: FETCH_ASSETRATINGS_SUCCESS,
    payload: { AttributesRating },
});


export const fetchAttributesAssetRatingsFailure = (errorMessage) => ({
    type: FETCH_ASSETRATINGS_FAILURE,
    payload: { errorMessage }
});

//rating actionidd
export const getAssetRatingsOddAction = (assetID) => {
    return (dispatch) => {
        dispatch(fetchAttributesAssetOddRatingsBegin());
        sbaAxios({
            url: `${getAssetRatings}${assetID},${2}`,
            method: 'get',
        })
            .then((repos) => {
                const AttributesOddRating = repos;
                dispatch(fetchAttributesAssetOddRatingsSuccess(AttributesOddRating));
                return AttributesOddRating;
            })
            .catch((error) => { return dispatch(fetchAttributesAssetOddRatingsFailure(error)) });
    };
}

export const fetchAttributesAssetOddRatingsBegin = () => ({
    type: FETCH_ASSETODDRATINGS_BEGIN,
});

export const fetchAttributesAssetOddRatingsSuccess = (AttributesOddRating) => ({
    type: FETCH_ASSETODDRATINGS_SUCCESS,
    payload: { AttributesOddRating },
});


export const fetchAttributesAssetOddRatingsFailure = (errorMessage) => ({
    type: FETCH_ASSETODDRATINGS_FAILURE,
    payload: { errorMessage }
});
